import * as products from './products';
import { selectActiveProduct } from './Products.reducer';

export const getActiveProduct = state => {
  const { key } = selectActiveProduct(state);
  return products[key];
};

export const activateProductOnEnter = (store, Product, dataMapper) => ({ params }, replaceState, cb) =>
  store
    .runSagaOnce(Product.activate.bind(Product), dataMapper(params))
    .toPromise()
    .finally(cb);
